"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Warning = function Warning() {
  return _react2.default.createElement(
    "g",
    { id: "warning" },
    _react2.default.createElement("path", {
      d: "M499.6508,397.754612 C502.640561,427.673834 486.212073,456.166238 458.820482,468.56782 C447.029693,473.930518 434.201427,476.627253 421.249391,476.465947 L78.7506088,476.465947 C65.7985733,476.627253 52.9703076,473.930518 41.1795182,468.56782 C13.7879263,456.166238 -2.64056075,427.673834 0.349200353,397.754612 C1.61834928,384.863337 5.71466391,372.410541 12.3463554,361.283261 L183.505768,65.6633618 C189.858388,54.366833 198.62462,44.6106453 209.17968,37.0901375 C233.602106,19.6366208 266.417889,19.6366208 290.840315,37.0901375 C301.395375,44.6106453 310.161608,54.366833 316.514227,65.6633618 L487.653645,361.283261 C494.285336,372.410541 498.381651,384.863337 499.6508,397.754612 Z M225.66577,148.013834 L274.33423,148.013834 L274.33423,294.029209 L225.66577,294.029209 L225.66577,148.013834 Z M225.66577,342.707666 L274.33423,342.707666 L274.33423,391.376125 L225.66577,391.376125 L225.66577,342.707666 Z M421.249391,427.7475 L421.249391,427.78749 C448.013045,427.78749 458.950451,408.831985 445.533633,385.667478 L274.384218,90.0475795 C267.675808,78.4603272 258.837904,72.6716999 250,72.6716999 C241.162096,72.6716999 232.324192,78.4603272 225.615782,90.0475795 L54.4663674,385.627488 C41.049549,408.752004 51.9769577,427.7475 78.7506088,427.7475 L421.249391,427.7475 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Warning;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Warning.js
// module id = 3008
// module chunks = 4